module.exports = __webpack_public_path__ + "fonts/iconfont.98b9f81.ttf";